import { useCallback, useEffect, useState } from "react";
import { useRequestMutation } from "hooks/useRequest";
import { History } from "models/AiResearch";

export const useHistoryList = () => {
  const [history, setHistory] = useState<History[]>([]);

  // 過去のチャット履歴を取得
  const { trigger: triggerHistoryList } = useRequestMutation<{
    historys: History[];
  }>("/sse/query/rag/history-list", "POST", {
    onSuccess: data => {
      setHistory(data.historys ?? []);
    }
  });

  // 履歴の特定アイテムを更新
  const replaceHistory = useCallback((history: History[]) => {
    setHistory(history);
  }, []);

  // 初期表示時、過去のチャット履歴を取得
  useEffect(() => {
    triggerHistoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { history, fetchHistoryList: triggerHistoryList, replaceHistory };
};
